import { COMPONENT_TYPES, staticRoutes } from '@atlas/routing';

export const SMARTICO_STORE = COMPONENT_TYPES.SMARTICO_STORE;

// Canonical route path for the Smartico Store page ('/account/store'), used as
// a fallback for entry points when `getComponentPath(SMARTICO_STORE)` is unset.
export const SMARTICO_STORE_PATH = staticRoutes.smarticoStore;
